import { UserWhereInput } from '@/@generated/codegen/API';
import { useQueryParams } from '@/hooks/useQueryParams';
import { QUERY_PARAM_GLOBAL_FILTER_KEY } from '@/hooks/useTableQueryParamsUtils';
import { parseBooleanQueryParam } from '@/utils/query-params/parseBooleanQueryParam';
import { parseDateQueryParam } from '@/utils/query-params/parseDateQueryParam';
import { parseStringQueryParam } from '@/utils/query-params/parseStringQueryParam';
import { useOrderByQueryParam } from '@/utils/query-params/useOrderByQueryParam';
import { usePaginationQueryParam } from '@/utils/query-params/usePaginationQueryParam';

export const useAdminUserListQueryParams = (pageSize: number, prefix: string | null) => {
  const queryObject = useQueryParams(
    [
      QUERY_PARAM_GLOBAL_FILTER_KEY,
      'createdAt',
      'updatedAt',
      'email',
      'isGuest',
      'clientName',
      'teamName',
    ],
    prefix
  );

  const { q, createdAt, updatedAt, email, isGuest, clientName, teamName } = queryObject;
  const orderByArgs = useOrderByQueryParam(prefix);
  const paginationArgs = usePaginationQueryParam(pageSize, prefix);
  const where: UserWhereInput = {
    AND: [
      q
        ? {
            OR: [
              { id: parseStringQueryParam(q) },
              { email: parseStringQueryParam(q) },
              {
                client: {
                  is: {
                    name: parseStringQueryParam(q),
                  },
                },
              },
              {
                team: {
                  is: {
                    name: parseStringQueryParam(q),
                  },
                },
              },
            ],
          }
        : {},
      {
        email: parseStringQueryParam(email),
        createdAt: parseDateQueryParam(createdAt),
        updatedAt: parseDateQueryParam(updatedAt),
        isGuest: parseBooleanQueryParam(isGuest),
      },
      clientName
        ? {
            client: {
              is: {
                name: parseStringQueryParam(clientName),
              },
            },
          }
        : {},
      teamName
        ? {
            team: {
              is: {
                name: parseStringQueryParam(teamName),
              },
            },
          }
        : {},
    ],
  };

  return {
    paginationArgs,
    orderByArgs,
    where,
  };
};
